module.exports = __webpack_public_path__ + "static/img/qrcode.1dec789f.png";